import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  Button,
  Spinner,
  Select
} from '../'

class TaskAssign extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  }

  state = {
    reassignTask: false,
    assignedTo: this.props.assignedTo,
    assignedToName: '',
  }

  goReadOnly = () => {
    this.setState({
      reassignTask: false
    })
  }

  handleReassign = () => {
    let taskInfo = {
      id: this.props.taskUUID,
      assignedTo: this.state.assignedTo
    }
    this.props.updateTaskAssigned({ variables: {input: taskInfo} })
    .then(this.goReadOnly)
    .catch((error) => {
      console.log('there was an error reassigning the task', error)
    })
  }

  render () {
    if (this.props.data.loading) {
      return <Spinner />
    }

    let reassignTaskButton = (
      <Button onClick={(e) => this.setState({reassignTask: true})}>Reassign Task</Button>
    )

    let saveReassignButton = (
      <Button type='brand' minWidth={100} onClick={this.handleReassign}>Save</Button>
    )

    let cancelReassignButton = (
      <Button minWidth={100} onClick={(e) => this.setState({ reassignTask: false })}>Cancel</Button>
    )

    let users = []
    this.props.data.responsibilities.edges.forEach(({ node: responsibility }) => {
      users.push({
        value: responsibility.identity.id,
        label: responsibility.identity.firstName + ' ' + responsibility.identity.lastName
      })
    })

    let chooseAssignment = (
      <Select
        id='assignedTo'
        label={this.props.label}
        placeholder=''
        value={this.state.payrollcycle}
        options={users}
        onChange={(e) => this.setState({ assignedTo: e.target.value })}
      />
    )

    if (this.state.reassignTask){
      return (
        <span>
          {chooseAssignment}
          <div className='slds-p-top_small'>
            {cancelReassignButton} {' '} {saveReassignButton}
          </div>
        </span>
      )
    } else {
      return (
        <span>
          {this.props.assignedToName}
          <div className='slds-p-top_small'>
            {reassignTaskButton}
          </div>
        </span>
      )
    }
  }
}

const getUsers = gql`query($taskResponsibility: String!) {
  responsibilities(description: $taskResponsibility) {
    edges {
      node {
        id
        identity {
          id
          firstName
          lastName
        }
      }
    }
  }
}
`

const updateTaskAssigned = gql`
  mutation updateTaskAssigned($input: WorkflowRunStepMutationInput!) {
    workflowrunstepMutate(input: $input) {
      workflowrunstep {
        ...WorkflowRunStep
      }
    }
  }
  ${fragments.workflowRunStep}
`

const withData = graphql(getUsers, {
  options: ({ taskResponsibility }) => ({
    variables: { taskResponsibility }
  })
})

const withUpdate =
  graphql(updateTaskAssigned, {
    name: 'updateTaskAssigned'
  })

export default withData(withUpdate(TaskAssign))



// WEBPACK FOOTER //
// ./src/components/task-assign/index.js